<template>
    <kgr-icon
        :icon-class="iconClass"
        :title="title"
        :small="small"
        :big="big"
        :circle="circle"
        :class="{ 'kgr-icon--active': !disabled }"
    />
</template>

<script>
import Icon from './Icon.vue';

export default {
    components: {
        'kgr-icon': Icon,
    },
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
        small: {
            type: Boolean,
            required: false,
        },
        big: {
            type: Boolean,
            required: false,
        },
        circle: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    computed: {
        iconClass() {
            if (!this.disabled) {
                return 'check';
            }
            return 'warning';
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .kgr-icon--active {
    background-color: green !important;
    color: white !important;
}
.kgr-icon {
    color: grey;
    background-color: lightgrey;
}
</style>
